<template>
  <div
    class="crad"
    @click="detailBtn"
    :style="{ border: isAtives_ ? '2px solid #157cf3' : '2px solid #d5d5d5' }"
  >
    <!-- <div class="crad-title">
      <el-tooltip
        class="item"
        effect="dark"
        :content="detailInfo.name"
        placement="top-start"
      >
        <span class="crad-title-span">{{
          detailInfo.name || detailInfo.code
        }}</span>
      </el-tooltip>
      <el-tooltip placement="right" :open-delay="1000">
        <div slot="content">
          浏览量：{{ detailInfo.statistical | filter_statistical }}
        </div>
        <div class="pageView">
          <browse :statistical="detailInfo.statistical"></browse>
        </div>
      </el-tooltip>
    </div> -->
    <div class="crad-li">
      <div class="crad-li-l">
        <img
          :src="
            detailInfo.imgUrl
              ? detailInfo.imgUrl
              : require('@/assets/images/home/land.png')
          "
          alt=""
          @click="investmentBtn"
        />
        <!-- <div class="titile" v-if="detailInfo.labels[0].length>0">
          
          {{ detailInfo.labels[0] ? detailInfo.labels[0].labelName : "" }}
        </div> -->
      </div>
      <div class="crad-li-r">
        <span class="crad-title-span">{{
          detailInfo.name || detailInfo.code
        }}</span>
        <div class="crad-li-r-li">
          <div class="crad-li-r-li-l">联系人：</div>
          <div class="crad-li-r-li-r">
            {{ detailInfo.person ? detailInfo.person : "--" }}
          </div>
        </div>
        <div class="crad-li-r-li">
          <div class="crad-li-r-li-l">联系方式：</div>
          <div class="crad-li-r-li-r">
            {{ detailInfo.phone ? detailInfo.phone : "--" }}
          </div>
        </div>
        <div class="crad-li-r-li">
          <div class="crad-li-r-li-r">
            {{
              detailInfo.parkName ? detailInfo.parkName : detailInfo.countyName
            }}
          </div>
          <div class="crad-li-r-li-r">{{ detailInfo.typeName }}</div>
          <div class="crad-li-r-li-r">{{ detailInfo.area }}亩</div>
        </div>
      </div>
    </div>
    <div class="crad-border">
      <div class="pageView">
        <el-tooltip placement="right" :open-delay="1000">
          <div slot="content">
            浏览量：{{ detailInfo.statistical | filter_statistical }}
          </div>
          <browse :statistical="detailInfo.statistical"></browse>
        </el-tooltip>
      </div>
      <div class="crad-button" v-if="detailInfo.supplyPeriod != 4">
        <button @click="addIntention($event)" v-if="!detailInfo.favorite">
          我有意向
        </button>
        <button
          :style="{ background: '#999999', color: '#fff', border: 'none' }"
          v-else
        >
          已加入意向地块列表
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import Browse from "@/components/currency/browse";
import { addFavorite, confirmFavorite } from "@/api/setting/investment";
export default {
  name: "park-crad",
  components: { Browse },
  props: {
    detailInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isAtives: {
      type: Boolean,
      default: false,
    },
    nowIndex: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      url: "",
      isAtives_: false,
      isRefresh: 0,
      isCollect: false, //是否收藏
    };
  },

  filters: {
    filter_statistical(value) {
      let value1 = 0;
      if (value > 10000) {
        value1 = (value / 10000).toFixed(1) + "万";
      } else {
        value1 = value;
      }
      return value1.toString();
    },
  },
  filters: {
    filter_statistical(value) {
      let value1 = 0;
      if (value > 10000) {
        value1 = (value / 10000).toFixed(1) + "万";
      } else {
        value1 = value;
      }
      return value1.toString();
    },
  },
  watch: {
    isAtives(val) {
      this.isAtives_ = this.isAtives;
    },
    isRefresh: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.popoverShow = !this.popoverShow;
        this.getList();
      }
    },
  },
  mounted() {
    if (this.isAtives) {
      this.isAtives_ = this.isAtives;
    }
  },
  methods: {
    detailBtn() {
      this.isAtives_ = !this.isAtives_;
      this.$emit("onDetail", this.detailInfo, this.isAtives_, this.nowIndex);
    },
    investmentBtn() {
      this.$emit("onInvestment", this.detailInfo);
    },
    parkLocation() {
      this.$emit("onParkLocation", this.detailInfo.parkCodeActual);
    },
    //添加意向地块
    addIntention(event) {
      event.stopPropagation(); //阻止事件冒泡
      this.token = sessionStorage.getItem("access_token");
      if (!this.token) {
        this.$eventBus.emit("isToken", false);
        return;
      }
      addFavorite({
        parcelId: this.detailInfo.id,
      }).then((res) => {
        this.isRefresh++;
        if (res.data.success) {
          this.$message.success(res.data.msg);
          this.$eventBus.emit("isRefresh", this.isRefresh);
          this.getIsCollect(this.detailInfo.id);
        } else {
          this.$message.error(res.data.msg);
          this.$eventBus.emit("isRefresh", this.isRefresh);
        }
      });
      this.$eventBus.emit("refreshLandList");
    },
    //是否收藏
    getIsCollect(id) {
      confirmFavorite(id).then((res) => {
        if (res.data.success) {
          this.isCollect = res.data.data;
        }
      });
    },
  },
};
</script>
<style  scoped>
.crad {
  border: 1px solid #f5f5f5;
  margin: 0 10px 10px 10px;
  cursor: pointer;
}

.crad-title {
  padding: 0 10px;
  height: 23px;
  line-height: 30px;
  font-size: 15px;
  font-weight: 600;
  color: #0a75da;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: flex;
  justify-content: space-between;
}

.crad-li {
  padding: 10px;
  font-size: 14px;
  display: flex;
}

.crad-li-l {
  width: 150px;
  height: 107px;
  position: relative;
}

.titile {
  position: absolute;
  left: 5px;
  top: 8px;
  max-width: 80px;
  background: #e56810;
  padding: 0 10px;
  border-radius: 4px;
  font-size: 12px;
  color: white;
  overflow: hidden;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 20px;
  height: 20px;
}

.crad-li-l > img {
  width: 100%;
  height: 100%;
}

.crad-li-r {
  width: calc(100% - 140px);
  padding-left: 10px;
  font-size: 12px;
}

.crad-li-r-li {
  display: flex;
  line-height: 22px;
}

.crad-li-r-li-l {
  width: 65px;
  color: rgb(78, 78, 78);
}

.crad-li-r-li-r {
  width: calc(100% - 50px);
  overflow: hidden;
  margin: 0 0 5px 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: rgb(114, 114, 114);
  /* text-align: center; */
}

.font-red {
  color: red;
  font-weight: 600;
}

.crad-title-span {
  display: inline-block;
  font-size: 16px;
  color: #2c83f6;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 190px;
  height: 20px;
  line-height: 20px;
  margin-bottom: 5px;
}

.crad-border {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 38px;

  border-top: 1px solid rgba(230, 230, 230, 0.5);
}

.pageView {
  margin-left: 10px;
}

.crad-button {
}

.crad-bottom,
button {
  border-radius: 6px;
  border: 1px solid #2c83f6;
  /* width: 80px; */
  height: 24px;
  font-size: 12px;
  margin-right: 10px;

  cursor: pointer;
  background: #2c83f6;
  color: #fff;
}
</style>


